// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__icpQr","input-container":"classes_input-container__wYHKQ","input":"classes_input__YSz1c","cross":"classes_cross__aCs1C"};